import React from "react";

const PrivacyStatement = () => {
  return (
    <div style={{ color: "#00267B" }}>
      <p>
        <strong>
          PLEASE READ THIS PRIVACY STATEMENT CAREFULLY BEFORE YOU (THE USER) USE
          <a href="http://www.lawnet.com.my"> www.lawnet.com.my </a> (&quot;the
          website&quot;)
        </strong>
      </p>
      <br />
      <p>
        At Lawnet, we take your privacy and your trust in us very seriously.
        This privacy statement provides you with information about how we
        collect, use and disclose your personal information in accordance with
        the Personal Data Protection Act 2010 (&quot;PDPA&quot;) and the laws of
        Malaysia.
      </p>
      <br />
      <h2>1. About This Privacy Statement</h2>
      <p>
        This privacy policy applies when you visit or use our websites,
        applications and other services, including events, that refer or link to
        this privacy statement (each, a &quot;Service&quot;). This privacy
        policy may be supplemented by additional privacy statements, terms or
        notices provided to you.
      </p>
      <br />
      <p>
        Lawnet, which owns or administers the Service as identified therein, is
        the primary controller of your personal information provided to, or
        collected by or for, the Service.
      </p>
      <br />
      <p>
        We will indicate within the registration processes of our products and
        services and other registration forms which types of personal
        information are required and those that are requested. You may choose
        not to submit the requested information, but this may limit or prohibit
        the services that Lawnet is able to provide to you.
      </p>
      <br />
      <h2>2. Information We Collect</h2>
      <p>
        Lawnet collects personal data such as name, email address, company
        details, address and telephone number. Information regarding your
        computer or device is also collected, which includes but is not limited
        to: IP address, browser type, domain names, access times and referring
        website addresses.
      </p>
      <br />
      <p>
        Lawnet may also contact you via surveys to conduct research about your
        opinion of current services or potential new services that may be
        offered.
      </p>
      <br />
      <p>
        Lawnet does not sell, rent or lease its customer lists to third parties.
        Lawnet may, from time to time, contact you on behalf of external
        business partners about a particular offering that may be of interest to
        you. In those cases, your unique personally identifiable information
        (email address, name, address, telephone number) is not transferred to
        the third party. All such third parties are prohibited from using your
        personal information except to provide these services to Lawnet, and
        they are required to maintain the confidentiality of your information.
      </p>
      <br />
      <h2>3. How We Use Your Information</h2>
      <p>
        Depending on how you interact with us and the Service, we use your
        personal information to:
      </p>
      <br />
      <ul style={{ marginLeft: "16px" }}>
        <li>
          Provide, activate and manage your access to and use of the Service
        </li>
        <li>
          Process and fulfil requests, orders, downloads, subscriptions or other
          transactions
        </li>
        <li>
          Provide technical, product and other support and to help keep the
          Service working, safe and secure
        </li>
        <li>
          Enhance and improve the Service and our other products, events and
          services, and to develop new products, services and benefits
        </li>
        <li>
          Offer you customised content and other personalisation to make the
          Service more relevant to your interests and geography
        </li>
        <li>Respond to your requests, enquiries, comments and concerns</li>
        <li>
          Notify you about changes, updates and other announcements related to
          the Service and our other products and services
        </li>
        <li>
          Deliver targeted advertisements, promotional messages, notices and
          other information related to the Service and your interests
        </li>
        <li>
          Provide you with promotional messages and other information about
          products, events and services of ours, our affiliates and third
          parties such as sponsors
        </li>
        <li>
          Invite you to participate in user testing and surveys as well as
          drawings, sweepstakes, competitions and similar promotions
        </li>
        <li>
          Identify usage trends and develop data analysis, including for
          purposes of research, audit, reporting and other business operations,
          including determining the effectiveness of our promotional campaigns
          and evaluating our business performance, or in other ways pursuant to
          a customer agreement
        </li>
        <li>
          Comply with our legal obligations, resolve disputes and enforce our
          agreements
        </li>
      </ul>
      <br/>
      <p>
        Lawnet does not use or disclose sensitive personal information such as
        race, religion or political affiliations without your explicit consent.
      </p>
      <br />
      <p>
        Lawnet keeps track of the websites and pages within Lawnet visited by
        our customers in order to determine which Lawnet services are the most
        popular. This data is used to deliver customised content and
        advertisements within Lawnet to customers whose behaviour indicates that
        they are interested in a particular subject area.
      </p>
      <br />
      <h2>4. Ground for Processing</h2>
      <p>
        When we collect or otherwise process any personal information within the
        scope of applicable data protection laws, we do so:
      </p>
      <br />
      <ul style={{ marginLeft: "16px" }}>
        <li>
          Where necessary to provide the Service, fulfil a transaction or
          otherwise perform a contract with you or at your request prior to
          entering into a contract
        </li>
        <li>
          Where necessary for our compliance with applicable law or other legal
          obligations
        </li>
        <li>
          Where necessary for the performance of a task carried out in the
          public interest
        </li>
        <li>
          Where necessary to enable our customers to comply with their legal
          obligations
        </li>
        <li>Where applicable, with your consent; and/or</li>
        <li>
          Where necessary to operate our business, protect the security of our
          systems, customers and users, detect or prevent fraud, or fulfil our
          other legitimate interests as described in Section 3 above, except
          where our interests are overridden by your privacy rights
        </li>
      </ul>
      <br />
      <p>
        Where we rely on your consent to process personal information, you have
        the right to withdraw your consent at any time. Where we rely on
        legitimate interests, you may have the right to object to our
        processing.
      </p>
      <br />
      <h2>5. Data Retention</h2>
      <p>
        We retain your personal information for as long as necessary to provide
        the Service and fulfil the transactions you have requested, or for other
        essential purposes such as complying with our legal obligations,
        maintaining business and financial records, resolving disputes, ensuring
        security, detecting and preventing fraud and abuse, and enforcing our
        agreements.
      </p>
      <br />
      <p>
        If you access the Service through a subscription administered or
        sponsored by your organisation, we retain your organisational contact
        details even after the termination of your organisation&#39;s
        subscription in order to continue communicating with you.
      </p>
      <br />
      <h2>6. Data Security</h2>
      <p>
        We implement technical and organisational measures to ensure a level of
        security appropriate to the risk associated with the personal
        information we process. These measures aim to safeguard the integrity,
        confidentiality and availability of personal information.
      </p>
      <br />
      <h2>7. Corrections and Cancellations</h2>
      <p>
        If your personal information is inaccurate, we will correct such
        information upon request. Please email your corrections to the Lawnet
        Administrator.{" "}
      </p>
      <br />
      <p>
        Upon request, we will cancel your registration, thereby removing you and
        your personal information from our database. Please direct your request
        via email to{" "}
        <a href="mailto:lawnet@printnasional.com.my">
          lawnet@printnasional.com.my
        </a>
        .
      </p>
      <br />
    </div>
  );
};

export default PrivacyStatement;
